<template lang="pug">
.correct-score-odds(v-if="odds" :class="[valueClass]" @click="placeBet($event.target)") {{ value }}
</template>
  
<script>
import config from "@/config";
import naming from "@/library/_name";
import { EventBus } from "@/library/_event-bus.js";

export default {
  props: {
    details: {
      type: [Object, Array]
    },
    odds: {
      type: Array
    },
    idx: {
      type: Number
    },
    typ: {
      type: String
    },
    cls: {
      type: String
    },
    dataType: {
      type: String
    },
    mode: {
      type: String
    },
    count: {
      type: [Number, String]
    },
    homeAway: {
      type: String
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      trigger: false,
      timer: null,
      old: null,
      dir: null,
      defStake: "",
      newPage: true
    };
  },
  computed: {
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    betType() {
      return this.$store.state.layout.menu3;
    },
    id() {
      if (this.odds) {
        return this.odds[3];
      } else {
        return null;
      }
    },
    value() {
      if (this.odds) {
        return this.odds[this.idx + 5];
      } else {
        return null;
      }
    },
    cssClass() {
      if (this.dir != null) {
        return this.dir;
      }
    },
    dv() {
      if (this.odds) {
        return parseFloat(this.odds[this.idx + 5]);
      } else {
        return 0;
      }
    },
    valueClass() {
      var result = [];
      if (this.cls) {
        result.push(this.cls);
      }
      if (!this.allowBet) {
        result.push("nb");
      }
      if (this.value < 0) {
        result.push("negetive");
      }
      return result;
    },
    allowBet() {
      return this.odds[39] == 1;
    },
    pause() {
      return false;
    },
    mixParlay() {
      return this.odds[38] == 1;
    }
  },
  watch: {
    dv(newVal, oldVal) {
      var nv = newVal;
      var ov = oldVal;
      if (nv == "" || nv == 0) {
        this.trigger = false;
        this.dir = null;
        return;
      } else {
        if (ov != nv) {
          this.trigger = true;
          if (nv < 0) {
            if (ov < nv) {
              this.dir = "decrease";
            } else {
              this.dir = "increase";
            }
          } else {
            if (ov > nv) {
              this.dir = "decrease";
            } else {
              this.dir = "increase";
            }
          }
          setTimeout(() => {
            this.trigger = false;
            this.dir = null;
          }, 10000);
        }
      }
      this.old = oldVal;
    },
    id(newVal, oldVal) {
      this.reset();
    },
    typ(newVal, oldVal) {
      this.reset();
    },
    betType(newVal, oldVal) {
      this.reset();
    },
    menu0() {
      this.reset();
    },
    menu1() {
      this.reset();
    },
    menu2() {
      this.reset();
    },
    menu3() {
      this.reset();
    }
  },
  methods: {
    reset() {
      this.trigger = false;
      this.old = null;
      this.dir = null;
    },
    placeBet(e) {
      // $(".odd-value").removeClass("selected-odds");
      // $(".odd").removeClass("selected-odds");
      if (this.allowBet) {
        if (this.$store.state.layout.betting.defaultStake == "0") {
          this.defStake = this.$store.state.layout.betting.defaultStakeAmount;
        } else {
          this.defStake = 5;
        }
        if (this.betType != "parlay") {
          setTimeout(() => {
            // $(e).addClass("selected-odds");
            // console.log($(e).closest('.odd').attr('class'))
            // $(e).closest('.odd').addClass("selected-odds");
          }, 10);
          if (EventBus.betSingle) {
            EventBus.betSingle(this.odds, this.typ, this.idx + 5, this.value, this.betType, this.defStake, this.mixParlay, null, e);
          }
        } else {
          if (this.mixParlay) {
            // if (Object.keys(this.$store.state.betparlay).length + 1 <= config.parlayMaxTicket) {
              if (EventBus.betParlay) {
                EventBus.betParlay(this.odds, this.typ, this.idx + 5, this.value, this.betType, this.defStake);
              }
            // } else {
            //   this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.maxParlayTicket"), "info");
            // }
          }
        }
      }
    },
    showOdds(bet_type, home_away, giving, odds) {
      return naming.ballDisplay3(odds, giving, home_away, bet_type, this);
    }
  }
};
</script>

  